import { Col, Divider, Row } from 'antd';
import { memo, ReactNode } from 'react';

interface IApprovalContentItemChildren {
  content: {
    title: string;
    content: ReactNode;
  }[];
}

export interface IApprovalContentItem {
  index?: number;
  title: string;
  children: IApprovalContentItemChildren[];
}

interface IApprovalBoard {
  // isOrderDetails?: boolean;
  // orderDetail?: string;
  data: IApprovalContentItem[];
}

const ApprovalBoard = ({
  data,
  // orderDetail,
  // isOrderDetails = true,
}: IApprovalBoard) => {
  return (
    <>
      <Row gutter={[0, 16]} className="mt-[30px]">
        {data.map((item, index: number) => {
          return (
            <Col span={24} key={index}>
              {item.children.length > 0 ? (
                <>
                  {item.title && (
                    <Row>
                      <Col>
                        <p className="text-[#000000] font-bold text-xl">
                          {item?.index ?? index + 1}. {item?.title}
                        </p>
                      </Col>
                    </Row>
                  )}
                  <Row className={`pl-[28px] ${item.title && 'pt-[12px]'}`}>
                    {item.children.map((item, index: number) => {
                      const titles = item.content.map((item) => item.title);
                      const contents = item.content.map((item) => item.content);

                      return (
                        <Col key={index} span={12}>
                          <Row gutter={[5, 0]}>
                            <Col>
                              {titles.map((title, index: number) => (
                                <Row
                                  key={index}
                                  className={index > 0 ? 'mt-[4px]' : ''}
                                >
                                  {title && (
                                    <p className="text-sm">{title}: </p>
                                  )}
                                </Row>
                              ))}
                            </Col>
                            <Col>
                              {contents.map((content, index: number) => (
                                <Row
                                  key={index}
                                  className={index > 0 ? 'mt-[4px]' : ''}
                                >
                                  <span className="font-semibold text-sm">
                                    {content || '-'}
                                  </span>
                                </Row>
                              ))}
                            </Col>
                          </Row>
                        </Col>
                      );
                    })}
                  </Row>
                </>
              ) : (
                <Divider
                  className="mx-[28px] my-0 w-auto min-w-max"
                  style={{ borderWidth: 2, borderStyle: 'dashed' }}
                />
              )}
            </Col>
          );
        })}
        {/* {isOrderDetails && ( */}
        {/* {orderDetail && (
          <Col span={24}>
            <Row>
              <Col>
                <p className="text-[#000000] font-bold text-xl">
                  {data.filter((item) => !!item.title).length + 1}. Chi tiết đơn
                </p>
                <p className="pl-[28px] pt-[12px]">
                  <p
                    // href="#"
                    className="text-[#0077CC] font-semibold no-underline text-sm"
                  >
                    Xem chi tiết
                  </p>
                </p>
              </Col>
            </Row>
          </Col>
        )} */}
      </Row>
    </>
  );
};

export default memo(ApprovalBoard);
